import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';
import { CommissioningRequestDtoModel } from '@bo-client/activation-management/shared/models/commissioningRequestDto';
import { DataForCustomFormModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable, of, Subject, switchMap } from 'rxjs';
import { CodeListValue } from '@bo-client/shared/models/codeListValue';
import { takeUntil } from 'rxjs/operators';
import { MetaService } from '@bo-client/core/api/meta-service';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Component({
  selector: 'app-cr-report-defect-form',
  templateUrl: './cr-report-defect-form.component.html',
  styleUrls: ['./cr-report-defect-form.component.scss']
})
export class CrReportDefectFormComponent
  implements
    CustomFormComponent<
      CommissioningRequestDtoModel,
      {
        comment: string;
      }
    >,
    OnDestroy
{
  constructor(
    private formBuilder: FormBuilder,
    private dataShareService: DataShareService,
    private metaService: MetaService
  ) {
    this.form = this.formBuilder.group({
      selectedDefects: this.formBuilder.control([]),
      comment: this.formBuilder.control('')
    });
    this.initDefectList();
  }
  private componentDestroyed$ = new Subject<void>();

  @Input() data: DataForCustomFormModel<CommissioningRequestDtoModel>;
  @Output() onConfirm = new EventEmitter<{
    additionalData: string[];
    comment: string;
  }>();

  form: FormGroup<{
    selectedDefects: FormControl<string[]>;
    comment: FormControl<string>;
  }>;

  defectList$: Observable<CodeListValue[]> = of([]);

  get isFormValid() {
    return this.form.valid;
  }

  cancel() {
    this.onConfirm.emit(null);
  }

  confirm() {
    const defectTextBlock = this.form.controls.selectedDefects.value
      .map((defect) => `- ${defect} \n`)
      .join('');
    const reportText = `${defectTextBlock ? `Festgestellte Mängel:\n${defectTextBlock}\n` : ''}${
      this.form.controls.comment.value
    }`;
    console.log(reportText);
    this.onConfirm.emit({
      additionalData:
        this.form.controls.selectedDefects.value?.length > 0
          ? this.form.controls.selectedDefects.value
          : null,
      comment: reportText
    });
  }

  private initDefectList() {
    this.defectList$ = this.dataShareService.currentTenant$.pipe(
      takeUntil(this.componentDestroyed$),
      switchMap((tenant) => {
        return this.metaService.codeListValues$('commissioning.defects', tenant.id);
      })
    );
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }
}
